import React from "react";
import Tooltip from "@mui/material/Tooltip";

export default function PTMTooltip(props) {
    const {
        children, sx, title, style, tooltipSx,
    } = props;

    const [open, setOpen] = React.useState(false);

    return (
        <Tooltip
            open={open}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            style={style}
            sx={{ ...sx, pointerEvents: "none" }}
            title={title}
            followCursor
            slotProps={{
                tooltip: {
                    sx: tooltipSx,
                },
            }}
        >
            <span className="ptm-tooltip-span">
                {children}
            </span>
        </Tooltip>
    );
}
